import { Types, types } from '../types'

const initialState = {
  waiting: false,
  success: false,
  error: '',
  profile: {},
  allMusicOnHold: [],
  narrator: [],
  operationLogs: []

}

const commonReducer = (state = initialState, { type, action, error, id, path, page, serviceType }) => {
  switch (type) {


    case types.GET_NARRATOR: {

      return {
        ...state,
        narrator: [{ Id: "4", Name: "آرمین" }, { Id: "5", Name: "آرمیتا" }]
      }
    }


    case types.GET_ALL_MUSIC_ON_HOLD: {
      return {
        ...state,
        allMusicOnHold: []

      }
    }

    case types.GET_ALL_MUSIC_ON_HOLD_SUCCESS: {
      return {
        ...state,
        allMusicOnHold: action.response


      }
    }


    case types.PUSH_RETURN_TO_OLD_ID: {
      return {
        ...state,
        returnToOldId: id,
        path: path,
        page: page
      }
    }


    case types.SET_LINE_SERVICE_TYPE: {
      return {
        ...state,
        serviceType: serviceType
      }
    }


    case types.GET_GTM_PURCHASE_INFO_REQUEST: {

      return {
        ...state,
        getPurchaseInfoWaiting: true,
        getPurchaseInfoSuccess: false,
        getPurchaseInfoError: '',

      }
    }

    case types.GET_GTM_PURCHASE_INFO_SUCCESS: {
      return {
        ...state,
        getPurchaseInfoWaiting: false,
        getPurchaseInfoSuccess: true,
        purchaseInfo: action.data
      }
    }

    case types.GET_GTM_PURCHASE_INFO_ERROR: {

      return {
        ...state,
        getPurchaseInfoWaiting: false,
        getPurchaseInfoError: '',
      }
    }


    case Types.OPERATION_LOGS_PUSH: {
      return {
        ...state,
        operationLogs: [...action]
      }
    }



    case types.COMMON_PROPS_RESET: {
      return {
        ...state,
        getPurchaseInfoWaiting: false,
        getPurchaseInfoSuccess: false,
        getPurchaseInfoError: '',
        purchaseInfo: null


      }
    }
    default:
      return state
  }
}

export default commonReducer;